import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { eskPartiApi } from '../services/api';

const TIPLER: Record<string, string> = {
  gebe_duve: 'Gebe Düve', bos_duve: 'Boş Düve', besilik: 'Besilik Sığır',
};
const BORCLANMA_TIPLERI: Record<string, string> = {
  karkas_mahsuplasma: 'Karkas Mahsuplaşma', vadeli_satis: 'Vadeli Satış',
};
const CIKIS_TIPLERI: Record<string, string> = {
  olen: 'Ölen', kesim: 'Kesim', canli_iade: 'Canlı İade', teslim_tutanagi: 'Teslim Anı Tutanağı',
};
const ALT_TIPLER: Record<string, Record<string, string>> = {
  olen: { normal: 'Olağan Ölüm', karantina_mensei_hastalik: 'Karantina — Menşe Ülke Kaynaklı Hastalık (borçtan mahsup)' },
  kesim: { normal: 'Normal Kesim', erken: 'Erken Kesim', sarta_tabi: 'Şarta Tabi (%70 fiyattan, borca sayılmaz)', acil_karantina_ici: 'Acil/Zorunlu — Karantina+10 Gün İçi (%10 eksik hesap yok)' },
  canli_iade: { gebe_kalmadi: '6 Ay İçinde Gebe Kalmadı', dogum_yapti_satilamadi: 'Doğum Yaptı, Satılamadı' },
  teslim_tutanagi: {},
};
const BOS_DUVE_TIPLERI: Record<string, string> = { kesim: 'Kesim', canli_iade: 'Canlı İade' };

const n = (v: any) => (v ?? 0).toLocaleString('tr-TR', { maximumFractionDigits: 2 });
const tl = (v: any) => `${n(v)} ₺`;
const editBtn = { background: '#f0f4f8', color: '#1a5276' };

export default function EskPartiDetay() {
  const { id } = useParams();
  const nav = useNavigate();
  const partiId = Number(id);

  const [parti, setParti] = useState<any>(null);
  const [ozet, setOzet] = useState<any>(null);
  const [ozetHata, setOzetHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState('');

  const [besilikForm, setBesilikForm] = useState<any>(null);

  const [cagriModal, setCagriModal] = useState(false);
  const [cagriSecili, setCagriSecili] = useState<any>(null);
  const [cagriForm, setCagriForm] = useState<any>({ cagri_no: '', hayvan_sayisi: 0, birim_fiyat_tl: 0, tarih: '', aciklama: '' });

  const [bakimModal, setBakimModal] = useState(false);
  const [bakimSecili, setBakimSecili] = useState<any>(null);
  const [bakimForm, setBakimForm] = useState<any>({ yil: new Date().getFullYear(), ay: 1, gun_orani: 1, memur_ucreti_tl: 0, disaridan_iscilik_tl: 0, yem_maliyeti_tl: 0, tahlil_ucreti_tl: 0, asi_ucreti_tl: 0, bakilan_hayvan_sayisi: 0, aciklama: '' });

  const [cikisModal, setCikisModal] = useState(false);
  const [cikisSecili, setCikisSecili] = useState<any>(null);
  const [cikisForm, setCikisForm] = useState<any>({ tip: 'olen', alt_tip: 'normal', hayvan_sayisi: 1, hayvan_cinsiyeti: '', giris_tarihi: '', cikis_tarihi: '', karkas_kg: '', canli_agirlik_kg: '', karkas_kg_fiyati: '', aciklama: '' });

  const buzagiBos = { satis_tarihi: '', satilan_sayi: 0, birim_fiyat_tl: 0, aciklama: '' };
  const [buzagiModal, setBuzagiModal] = useState(false);
  const [buzagiSecili, setBuzagiSecili] = useState<any>(null);
  const [buzagiForm, setBuzagiForm] = useState<any>(buzagiBos);

  const yemBos = { hayvan_sayisi: 0, aylik_tutar_tl: 0, aciklama: '' };
  const [yemModal, setYemModal] = useState(false);
  const [yemSecili, setYemSecili] = useState<any>(null);
  const [yemForm, setYemForm] = useState<any>(yemBos);

  const tarsimBos = { hayvan_sayisi: 0, birim_tutar_tl: 0, aciklama: '' };
  const [tarsimModal, setTarsimModal] = useState(false);
  const [tarsimSecili, setTarsimSecili] = useState<any>(null);
  const [tarsimForm, setTarsimForm] = useState<any>(tarsimBos);

  const bosDuveBos = { tip: 'kesim', hayvan_sayisi: 0, ortalama_canli_agirlik_kg: 0, karkas_randiman_pct: '', karkas_kg_fiyati: 0, aciklama: '' };
  const [bosDuveModal, setBosDuveModal] = useState(false);
  const [bosDuveSecili, setBosDuveSecili] = useState<any>(null);
  const [bosDuveForm, setBosDuveForm] = useState<any>(bosDuveBos);

  const bakimDestegiBos = { hayvan_sayisi: 0, aylik_tutar_tl: 0, aciklama: '' };
  const [bakimDestegiModal, setBakimDestegiModal] = useState(false);
  const [bakimDestegiSecili, setBakimDestegiSecili] = useState<any>(null);
  const [bakimDestegiForm, setBakimDestegiForm] = useState<any>(bakimDestegiBos);

  const yukle = () => {
    setYukleniyor(true);
    eskPartiApi.partiDetay(partiId).then(r => {
      setParti(r.data);
      setBesilikForm(r.data.besilik_detay || { ortalama_canli_agirlik_kg: 0, canli_kg_alis_fiyati_tl: 0, gunluk_bakim_gideri_tl: null });
    }).catch(() => setHata('Parti yüklenemedi')).finally(() => setYukleniyor(false));

    eskPartiApi.partiOzet(partiId).then(r => { setOzet(r.data.ozet); setOzetHata(''); })
      .catch((e: any) => { setOzet(null); setOzetHata(e.response?.status === 403 ? 'Kâr-zarar özetini görüntüleme yetkiniz yok.' : 'Özet hesaplanamadı'); });
  };

  useEffect(() => { yukle(); }, [partiId]);

  const besilikDetayKaydet = async () => {
    try { await eskPartiApi.besilikDetaySave(partiId, besilikForm); yukle(); }
    catch (e: any) { alert(e.response?.data?.detail || 'Kaydedilemedi'); }
  };

  // ── Satış Çağrıları ──
  const cagriBosForm = { cagri_no: '', hayvan_sayisi: 0, birim_fiyat_tl: 0, tarih: '', aciklama: '' };
  const cagriEkleAc = () => { setCagriSecili(null); setCagriForm(cagriBosForm); setCagriModal(true); };
  const cagriDuzenleAc = (c: any) => { setCagriSecili(c); setCagriForm({ cagri_no: c.cagri_no, hayvan_sayisi: c.hayvan_sayisi, birim_fiyat_tl: c.birim_fiyat_tl, tarih: c.tarih || '', aciklama: c.aciklama || '' }); setCagriModal(true); };
  const cagriEkle = async () => {
    try {
      const body = { ...cagriForm, tarih: cagriForm.tarih || null };
      if (cagriSecili) await eskPartiApi.satisCagrisiGuncelle(cagriSecili.id, body);
      else await eskPartiApi.satisCagrisiEkle(partiId, body);
      setCagriModal(false); setCagriSecili(null); setCagriForm(cagriBosForm); yukle();
    } catch (e: any) { alert(e.response?.data?.detail || 'Kaydedilemedi'); }
  };
  const cagriSil = async (cid: number) => { if (!window.confirm('Silinsin mi?')) return; await eskPartiApi.satisCagrisiSil(cid); yukle(); };

  // ── Aylık Bakım ──
  const bakimBosForm = { yil: new Date().getFullYear(), ay: 1, gun_orani: 1, memur_ucreti_tl: 0, disaridan_iscilik_tl: 0, yem_maliyeti_tl: 0, tahlil_ucreti_tl: 0, asi_ucreti_tl: 0, bakilan_hayvan_sayisi: 0, aciklama: '' };
  const bakimEkleAc = () => { setBakimSecili(null); setBakimForm(bakimBosForm); setBakimModal(true); };
  const bakimDuzenleAc = (k: any) => {
    setBakimSecili(k);
    setBakimForm({
      yil: k.yil, ay: k.ay, gun_orani: k.gun_orani ?? 1, memur_ucreti_tl: k.memur_ucreti_tl || 0,
      disaridan_iscilik_tl: k.disaridan_iscilik_tl || 0, yem_maliyeti_tl: k.yem_maliyeti_tl || 0,
      tahlil_ucreti_tl: k.tahlil_ucreti_tl || 0, asi_ucreti_tl: k.asi_ucreti_tl || 0,
      bakilan_hayvan_sayisi: k.bakilan_hayvan_sayisi || 0, aciklama: k.aciklama || '',
    });
    setBakimModal(true);
  };
  const bakimEkle = async () => {
    try {
      if (bakimSecili) await eskPartiApi.aylikBakimGuncelle(bakimSecili.id, bakimForm);
      else await eskPartiApi.aylikBakimEkle(partiId, bakimForm);
      setBakimModal(false); setBakimSecili(null); yukle();
    } catch (e: any) { alert(e.response?.data?.detail || 'Kaydedilemedi'); }
  };
  const bakimSil = async (bid: number) => { if (!window.confirm('Silinsin mi?')) return; await eskPartiApi.aylikBakimSil(bid); yukle(); };

  // ── Çıkış Kayıtları ──
  const cikisBosForm = { tip: 'olen', alt_tip: 'normal', hayvan_sayisi: 1, hayvan_cinsiyeti: '', giris_tarihi: '', cikis_tarihi: '', karkas_kg: '', canli_agirlik_kg: '', karkas_kg_fiyati: '', aciklama: '' };
  const cikisEkleAc = () => { setCikisSecili(null); setCikisForm(cikisBosForm); setCikisModal(true); };
  const cikisDuzenleAc = (c: any) => {
    setCikisSecili(c);
    setCikisForm({
      tip: c.tip, alt_tip: c.alt_tip || '', hayvan_sayisi: c.hayvan_sayisi || 1,
      hayvan_cinsiyeti: c.hayvan_cinsiyeti || '', giris_tarihi: c.giris_tarihi || '', cikis_tarihi: c.cikis_tarihi || '',
      karkas_kg: c.karkas_kg ?? '', canli_agirlik_kg: c.canli_agirlik_kg ?? '', karkas_kg_fiyati: c.karkas_kg_fiyati ?? '',
      aciklama: c.aciklama || '',
    });
    setCikisModal(true);
  };
  const cikisEkle = async () => {
    if (!cikisForm.cikis_tarihi) { alert('Çıkış tarihi zorunlu'); return; }
    try {
      const body = {
        ...cikisForm,
        hayvan_sayisi: Number(cikisForm.hayvan_sayisi) || 1,
        hayvan_cinsiyeti: cikisForm.hayvan_cinsiyeti || null,
        giris_tarihi: cikisForm.giris_tarihi || null,
        karkas_kg: cikisForm.karkas_kg !== '' ? Number(cikisForm.karkas_kg) : null,
        canli_agirlik_kg: cikisForm.canli_agirlik_kg !== '' ? Number(cikisForm.canli_agirlik_kg) : null,
        karkas_kg_fiyati: cikisForm.karkas_kg_fiyati !== '' ? Number(cikisForm.karkas_kg_fiyati) : null,
      };
      const res = cikisSecili
        ? await eskPartiApi.cikisKaydiGuncelle(cikisSecili.id, body)
        : await eskPartiApi.cikisKaydiEkle(partiId, body);
      if (res.data.uyari) alert(`⚠️ ${res.data.uyari}`);
      setCikisModal(false); setCikisSecili(null); yukle();
    } catch (e: any) { alert(e.response?.data?.detail || 'Kaydedilemedi'); }
  };
  const cikisSil = async (cid: number) => { if (!window.confirm('Silinsin mi?')) return; await eskPartiApi.cikisKaydiSil(cid); yukle(); };

  // ── Buzağı Satışı ──
  const buzagiEkleAc = () => { setBuzagiSecili(null); setBuzagiForm(buzagiBos); setBuzagiModal(true); };
  const buzagiDuzenleAc = (b: any) => { setBuzagiSecili(b); setBuzagiForm({ satis_tarihi: b.satis_tarihi || '', satilan_sayi: b.satilan_sayi, birim_fiyat_tl: b.birim_fiyat_tl, aciklama: b.aciklama || '' }); setBuzagiModal(true); };
  const buzagiEkle = async () => {
    try {
      const body = { ...buzagiForm, satis_tarihi: buzagiForm.satis_tarihi || null };
      if (buzagiSecili) await eskPartiApi.buzagiSatisGuncelle(buzagiSecili.id, body);
      else await eskPartiApi.buzagiSatisEkle(partiId, body);
      setBuzagiModal(false); setBuzagiSecili(null); yukle();
    } catch (e: any) { alert(e.response?.data?.detail || 'Kaydedilemedi'); }
  };
  const buzagiSil = async (bid: number) => { if (!window.confirm('Silinsin mi?')) return; await eskPartiApi.buzagiSatisSil(bid); yukle(); };

  // ── Yem Desteği ──
  const yemEkleAc = () => { setYemSecili(null); setYemForm(yemBos); setYemModal(true); };
  const yemDuzenleAc = (y: any) => { setYemSecili(y); setYemForm({ hayvan_sayisi: y.hayvan_sayisi, aylik_tutar_tl: y.aylik_tutar_tl, aciklama: y.aciklama || '' }); setYemModal(true); };
  const yemEkle = async () => {
    try {
      if (yemSecili) await eskPartiApi.yemDestegiGuncelle(yemSecili.id, yemForm);
      else await eskPartiApi.yemDestegiEkle(partiId, yemForm);
      setYemModal(false); setYemSecili(null); yukle();
    } catch (e: any) { alert(e.response?.data?.detail || 'Kaydedilemedi'); }
  };
  const yemSil = async (yid: number) => { if (!window.confirm('Silinsin mi?')) return; await eskPartiApi.yemDestegiSil(yid); yukle(); };

  // ── Tarsım ──
  const tarsimEkleAc = () => { setTarsimSecili(null); setTarsimForm(tarsimBos); setTarsimModal(true); };
  const tarsimDuzenleAc = (t: any) => { setTarsimSecili(t); setTarsimForm({ hayvan_sayisi: t.hayvan_sayisi, birim_tutar_tl: t.birim_tutar_tl, aciklama: t.aciklama || '' }); setTarsimModal(true); };
  const tarsimEkle = async () => {
    try {
      if (tarsimSecili) await eskPartiApi.tarsimGuncelle(tarsimSecili.id, tarsimForm);
      else await eskPartiApi.tarsimEkle(partiId, tarsimForm);
      setTarsimModal(false); setTarsimSecili(null); yukle();
    } catch (e: any) { alert(e.response?.data?.detail || 'Kaydedilemedi'); }
  };
  const tarsimSil = async (tid: number) => { if (!window.confirm('Silinsin mi?')) return; await eskPartiApi.tarsimSil(tid); yukle(); };

  // ── Kalan Boş Düve (Kesim / Canlı İade) ──
  const bosDuveEkleAc = () => { setBosDuveSecili(null); setBosDuveForm(bosDuveBos); setBosDuveModal(true); };
  const bosDuveDuzenleAc = (b: any) => {
    setBosDuveSecili(b);
    setBosDuveForm({ tip: b.tip, hayvan_sayisi: b.hayvan_sayisi, ortalama_canli_agirlik_kg: b.ortalama_canli_agirlik_kg, karkas_randiman_pct: b.karkas_randiman_pct ?? '', karkas_kg_fiyati: b.karkas_kg_fiyati, aciklama: b.aciklama || '' });
    setBosDuveModal(true);
  };
  const bosDuveEkle = async () => {
    try {
      const body = { ...bosDuveForm, karkas_randiman_pct: bosDuveForm.tip === 'kesim' && bosDuveForm.karkas_randiman_pct !== '' ? Number(bosDuveForm.karkas_randiman_pct) : null };
      if (bosDuveSecili) await eskPartiApi.bosDuveGuncelle(bosDuveSecili.id, body);
      else await eskPartiApi.bosDuveEkle(partiId, body);
      setBosDuveModal(false); setBosDuveSecili(null); yukle();
    } catch (e: any) { alert(e.response?.data?.detail || 'Kaydedilemedi'); }
  };
  const bosDuveSil = async (bid: number) => { if (!window.confirm('Silinsin mi?')) return; await eskPartiApi.bosDuveSil(bid); yukle(); };

  // ── Bakım Desteği Verilmeyen Hayvan Sayısı ──
  const bakimDestegiEkleAc = () => { setBakimDestegiSecili(null); setBakimDestegiForm(bakimDestegiBos); setBakimDestegiModal(true); };
  const bakimDestegiDuzenleAc = (b: any) => { setBakimDestegiSecili(b); setBakimDestegiForm({ hayvan_sayisi: b.hayvan_sayisi, aylik_tutar_tl: b.aylik_tutar_tl, aciklama: b.aciklama || '' }); setBakimDestegiModal(true); };
  const bakimDestegiEkle = async () => {
    try {
      if (bakimDestegiSecili) await eskPartiApi.bakimDestegiVerilmeyenGuncelle(bakimDestegiSecili.id, bakimDestegiForm);
      else await eskPartiApi.bakimDestegiVerilmeyenEkle(partiId, bakimDestegiForm);
      setBakimDestegiModal(false); setBakimDestegiSecili(null); yukle();
    } catch (e: any) { alert(e.response?.data?.detail || 'Kaydedilemedi'); }
  };
  const bakimDestegiSil = async (bid: number) => { if (!window.confirm('Silinsin mi?')) return; await eskPartiApi.bakimDestegiVerilmeyenSil(bid); yukle(); };

  const odemeKaydet = async (taksitId: number, mevcutTutar: number) => {
    const girilen = window.prompt('Ödenen tutar (TL):', String(mevcutTutar || ''));
    if (girilen === null) return;
    const tarih = window.prompt('Ödeme tarihi (YYYY-MM-DD):', new Date().toISOString().slice(0, 10));
    if (!tarih) return;
    try { await eskPartiApi.odemeKaydet(taksitId, { odenen_tutar_tl: Number(girilen), odeme_tarihi: tarih }); yukle(); }
    catch (e: any) { alert(e.response?.data?.detail || 'Kaydedilemedi'); }
  };

  if (yukleniyor) return <div className="card">Yükleniyor...</div>;
  if (hata || !parti) return <div className="card"><div className="alert alert-danger">{hata || 'Parti bulunamadı'}</div></div>;

  return (
    <div>
      <div className="page-header">
        <button className="btn" style={{ background: '#eee', marginBottom: 8 }} onClick={() => nav('/esk-parti')}>← Parti Listesine Dön</button>
        <h1>🐂 {parti.isletme_ad} — {parti.parti_no}</h1>
        <p>{TIPLER[parti.tip]} · {BORCLANMA_TIPLERI[parti.borclanma_tipi]} · Teslim: {parti.teslim_tarihi || '-'}</p>
      </div>

      {ozet && (
        <div className="stats-grid">
          <div className="stat-card"><div className="stat-icon">💰</div><div><div className="stat-value">{tl(ozet.toplam_maliyet)}</div><div className="stat-label">Toplam Maliyet</div></div></div>
          <div className="stat-card"><div className="stat-icon">🐮</div><div><div className="stat-value">{tl(ozet.hayvan_basi_toplam_maliyet)}</div><div className="stat-label">Hayvan Başı Güncel Toplam Maliyet</div></div></div>
          {parti.tip !== 'besilik' ? (
            <>
              <div className="stat-card"><div className="stat-icon">📈</div><div><div className="stat-value">{tl(ozet.toplam_gelir)}</div><div className="stat-label">Toplam Gelir</div></div></div>
              <div className="stat-card"><div className="stat-icon">{ozet.kar_zarar >= 0 ? '✅' : '⚠️'}</div><div><div className="stat-value" style={{ color: ozet.kar_zarar >= 0 ? '#1e8449' : '#c0392b' }}>{tl(ozet.kar_zarar)}</div><div className="stat-label">Kâr/Zarar</div></div></div>
              <div className="stat-card"><div className="stat-icon">🐄</div><div><div className="stat-value" style={{ color: ozet.hayvan_basi_kar_zarar >= 0 ? '#1e8449' : '#c0392b' }}>{tl(ozet.hayvan_basi_kar_zarar)}</div><div className="stat-label">Hayvan Başına Kâr/Zarar</div></div></div>
            </>
          ) : (
            <>
              <div className="stat-card"><div className="stat-icon">🥩</div><div><div className="stat-value">{n(ozet.toplam_karkas_uretimi_kg)} kg</div><div className="stat-label">Toplam Karkas Üretimi</div></div></div>
              <div className="stat-card"><div className="stat-icon">⚖️</div><div><div className="stat-value">{ozet.karkas_borcu_kg != null ? `${n(ozet.karkas_borcu_kg)} kg` : '-'}</div><div className="stat-label">Karkas Borcu</div></div></div>
              <div className="stat-card"><div className="stat-icon">{(ozet.karkas_kg_kar_zarar ?? 0) >= 0 ? '✅' : '⚠️'}</div><div><div className="stat-value">{ozet.karkas_kg_kar_zarar != null ? `${n(ozet.karkas_kg_kar_zarar)} kg` : '-'}</div><div className="stat-label">Karkas Kg Kâr/Borç</div></div></div>
            </>
          )}
        </div>
      )}
      {ozetHata && <div className="card" style={{ color: '#888', fontSize: 13 }}>{ozetHata}</div>}

      {/* Geliş / Borç */}
      <div className="card">
        <h3 style={{ marginTop: 0 }}>Geliş / Borç Bilgisi</h3>
        <div className="form-row">
          <div className="form-group"><label>Gelen Hayvan Sayısı</label><div>{n(parti.gelen_hayvan_sayisi)}</div></div>
          <div className="form-group"><label>ESK Kombina</label><div>{parti.esk_kombina || '-'}</div></div>
          {parti.borclanma_tipi === 'karkas_mahsuplasma' ? (
            <div className="form-group"><label>ESK Fatura Tutarı</label><div>{tl(parti.esk_fatura_tutari_tl)}</div></div>
          ) : (
            <div className="form-group"><label>Vadeli Birim Fiyat</label><div>{tl(parti.vadeli_birim_fiyat_tl)}</div></div>
          )}
          <div className="form-group"><label>Karkas Kg Fiyatı</label><div>{tl(parti.karkas_kg_fiyati)}</div></div>
          <div className="form-group">
            <label>Hayvan Başı Geliş Maliyeti <small style={{ color: '#999', fontWeight: 'normal' }}>(sabit)</small></label>
            <div>{ozet ? tl(ozet.hayvan_basi_gelis_maliyeti) : (parti.gelen_hayvan_sayisi
              ? tl((parti.borclanma_tipi === 'karkas_mahsuplasma'
                  ? (parti.esk_fatura_tutari_tl || 0) / parti.gelen_hayvan_sayisi
                  : (parti.vadeli_birim_fiyat_tl || 0)))
              : '-')}</div>
          </div>
        </div>
        {ozet && (
          <div style={{ fontSize: 13, color: '#1a5276', background: '#eaf2fb', padding: '8px 12px', borderRadius: 4, marginTop: 4 }}>
            <strong>Hayvan Başı Güncel Toplam Maliyet: {tl(ozet.hayvan_basi_toplam_maliyet)}</strong>
            <div style={{ fontSize: 11, color: '#555', marginTop: 2 }}>
              Geliş maliyeti + bakım/besleme gideri + yem desteği + Tarsım + çıkış kayıtlarından gelen zarar toplanıp
              hayvan sayısına bölünür; her yeni gider/çıkış kaydı girildikçe otomatik güncellenir.
            </div>
          </div>
        )}
        {ozet?.karkas_borcu_kg != null && (
          <div style={{ fontSize: 13, color: '#555', marginTop: 8 }}>Hesaplanan karkas borcu: <strong>{n(ozet.karkas_borcu_kg)} kg</strong></div>
        )}
      </div>

      {/* Besilik Detay */}
      {parti.tip === 'besilik' && (
        <div className="card">
          <h3 style={{ marginTop: 0 }}>Besilik Detay</h3>
          <div className="form-row">
            <div className="form-group"><label>Ortalama Canlı Ağırlık (kg)</label><input className="form-control" type="number" value={besilikForm?.ortalama_canli_agirlik_kg} onChange={e => setBesilikForm({ ...besilikForm, ortalama_canli_agirlik_kg: Number(e.target.value) })} /></div>
            <div className="form-group"><label>Canlı Kg Alış Fiyatı (TL)</label><input className="form-control" type="number" value={besilikForm?.canli_kg_alis_fiyati_tl} onChange={e => setBesilikForm({ ...besilikForm, canli_kg_alis_fiyati_tl: Number(e.target.value) })} /></div>
            <div className="form-group"><label>Günlük Bakım Gideri (TL, opsiyonel yedek)</label><input className="form-control" type="number" value={besilikForm?.gunluk_bakim_gideri_tl || ''} onChange={e => setBesilikForm({ ...besilikForm, gunluk_bakim_gideri_tl: e.target.value ? Number(e.target.value) : null })} /></div>
          </div>
          <button className="btn btn-primary btn-sm" onClick={besilikDetayKaydet}>Kaydet</button>
        </div>
      )}

      {/* Satış Çağrıları — sadece düve partilerinde */}
      {parti.tip !== 'besilik' && (
        <div className="card">
          <div className="toolbar">
            <h3 style={{ margin: 0 }}>Satış Çağrı Grupları (İhale)</h3>
            <button className="btn btn-success btn-sm" onClick={cagriEkleAc}>+ Çağrı Ekle</button>
          </div>
          <table>
            <thead><tr><th>Çağrı No</th><th>Hayvan Sayısı</th><th>Birim Fiyat</th><th>Tarih</th><th>Tutar</th><th></th></tr></thead>
            <tbody>
              {parti.satis_cagrilari.map((c: any) => (
                <tr key={c.id}>
                  <td>{c.cagri_no}</td><td>{n(c.hayvan_sayisi)}</td><td>{tl(c.birim_fiyat_tl)}</td><td>{c.tarih || '-'}</td>
                  <td>{tl(c.hayvan_sayisi * c.birim_fiyat_tl)}</td>
                  <td style={{ display: 'flex', gap: 4 }}>
                    <button className="btn btn-sm" style={editBtn} onClick={() => cagriDuzenleAc(c)}>Düzenle</button>
                    <button className="btn btn-danger btn-sm" onClick={() => cagriSil(c.id)}>Sil</button>
                  </td>
                </tr>
              ))}
              {parti.satis_cagrilari.length === 0 && <tr><td colSpan={6} style={{ textAlign: 'center', color: '#999' }}>Henüz kayıt yok</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {/* Buzağı Satışı — sadece düve partilerinde */}
      {parti.tip !== 'besilik' && (
        <div className="card">
          <div className="toolbar">
            <h3 style={{ margin: 0 }}>Buzağı Satışı</h3>
            <button className="btn btn-success btn-sm" onClick={buzagiEkleAc}>+ Satış Ekle</button>
          </div>
          <table>
            <thead><tr><th>Satış Tarihi</th><th>Satılan Sayı</th><th>Birim Fiyat</th><th>Toplam Tutar</th><th></th></tr></thead>
            <tbody>
              {parti.buzagi_satislari.map((b: any) => (
                <tr key={b.id}>
                  <td>{b.satis_tarihi || '-'}</td><td>{n(b.satilan_sayi)}</td><td>{tl(b.birim_fiyat_tl)}</td>
                  <td><strong style={{ color: '#1e8449' }}>{tl((b.satilan_sayi || 0) * (b.birim_fiyat_tl || 0))}</strong></td>
                  <td style={{ display: 'flex', gap: 4 }}>
                    <button className="btn btn-sm" style={editBtn} onClick={() => buzagiDuzenleAc(b)}>Düzenle</button>
                    <button className="btn btn-danger btn-sm" onClick={() => buzagiSil(b.id)}>Sil</button>
                  </td>
                </tr>
              ))}
              {parti.buzagi_satislari.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', color: '#999' }}>Henüz kayıt yok</td></tr>}
            </tbody>
          </table>
          {ozet && <div style={{ marginTop: 10, fontSize: 13, color: '#555' }}>Toplam buzağı satış geliri: <strong style={{ color: '#1e8449' }}>{tl(ozet.buzagi_geliri)}</strong></div>}
        </div>
      )}

      {/* Yem Desteği — sadece düve partilerinde */}
      {parti.tip !== 'besilik' && (
        <div className="card">
          <div className="toolbar">
            <h3 style={{ margin: 0 }}>Yem Desteği</h3>
            <button className="btn btn-success btn-sm" onClick={yemEkleAc}>+ Kayıt Ekle</button>
          </div>
          <table>
            <thead><tr><th>Hayvan Sayısı</th><th>Aylık Tutar (baş)</th><th>Yıllık Toplam Gider</th><th></th></tr></thead>
            <tbody>
              {parti.yem_destekleri.map((y: any) => (
                <tr key={y.id}>
                  <td>{n(y.hayvan_sayisi)}</td><td>{tl(y.aylik_tutar_tl)}</td>
                  <td><strong style={{ color: '#c0392b' }}>{tl((y.hayvan_sayisi || 0) * (y.aylik_tutar_tl || 0) * 12)}</strong></td>
                  <td style={{ display: 'flex', gap: 4 }}>
                    <button className="btn btn-sm" style={editBtn} onClick={() => yemDuzenleAc(y)}>Düzenle</button>
                    <button className="btn btn-danger btn-sm" onClick={() => yemSil(y.id)}>Sil</button>
                  </td>
                </tr>
              ))}
              {parti.yem_destekleri.length === 0 && <tr><td colSpan={4} style={{ textAlign: 'center', color: '#999' }}>Henüz kayıt yok</td></tr>}
            </tbody>
          </table>
          {ozet && <div style={{ marginTop: 10, fontSize: 13, color: '#555' }}>Toplam yem desteği gideri: <strong style={{ color: '#c0392b' }}>{tl(ozet.yem_destegi_toplam)}</strong></div>}
        </div>
      )}

      {/* Tarsım — sadece düve partilerinde */}
      {parti.tip !== 'besilik' && (
        <div className="card">
          <div className="toolbar">
            <h3 style={{ margin: 0 }}>Tarsım</h3>
            <button className="btn btn-success btn-sm" onClick={tarsimEkleAc}>+ Kayıt Ekle</button>
          </div>
          <table>
            <thead><tr><th>Hayvan Sayısı</th><th>Birim Tutar</th><th>Toplam Gider</th><th></th></tr></thead>
            <tbody>
              {parti.tarsimlar.map((t: any) => (
                <tr key={t.id}>
                  <td>{n(t.hayvan_sayisi)}</td><td>{tl(t.birim_tutar_tl)}</td>
                  <td><strong style={{ color: '#c0392b' }}>{tl((t.hayvan_sayisi || 0) * (t.birim_tutar_tl || 0))}</strong></td>
                  <td style={{ display: 'flex', gap: 4 }}>
                    <button className="btn btn-sm" style={editBtn} onClick={() => tarsimDuzenleAc(t)}>Düzenle</button>
                    <button className="btn btn-danger btn-sm" onClick={() => tarsimSil(t.id)}>Sil</button>
                  </td>
                </tr>
              ))}
              {parti.tarsimlar.length === 0 && <tr><td colSpan={4} style={{ textAlign: 'center', color: '#999' }}>Henüz kayıt yok</td></tr>}
            </tbody>
          </table>
          {ozet && <div style={{ marginTop: 10, fontSize: 13, color: '#555' }}>Toplam Tarsım gideri: <strong style={{ color: '#c0392b' }}>{tl(ozet.tarsim_toplam)}</strong></div>}
        </div>
      )}

      {/* Kalan Boş Düve — sadece düve partilerinde */}
      {parti.tip !== 'besilik' && (
        <div className="card">
          <div className="toolbar">
            <h3 style={{ margin: 0 }}>Kalan Boş Düve (Kesim / Canlı İade)</h3>
            <button className="btn btn-success btn-sm" onClick={bosDuveEkleAc}>+ Kayıt Ekle</button>
          </div>
          <table>
            <thead><tr><th>Tip</th><th>Hayvan Sayısı</th><th>Ort. Canlı Ağırlık</th><th>Randıman</th><th>Karkas Kg Fiyatı</th><th>Karkas Kg</th><th>Getiri (TL)</th><th></th></tr></thead>
            <tbody>
              {parti.bos_duveler.map((b: any) => {
                const randiman = b.tip === 'canli_iade' ? 0.50 : (b.karkas_randiman_pct ?? null);
                const kg = randiman != null ? (b.hayvan_sayisi || 0) * (b.ortalama_canli_agirlik_kg || 0) * randiman : null;
                const tutar = kg != null ? kg * (b.karkas_kg_fiyati || 0) : null;
                return (
                  <tr key={b.id}>
                    <td>{BOS_DUVE_TIPLERI[b.tip] || b.tip}</td>
                    <td>{n(b.hayvan_sayisi)}</td><td>{n(b.ortalama_canli_agirlik_kg)} kg</td>
                    <td>{b.tip === 'canli_iade' ? '%50 (sabit)' : (b.karkas_randiman_pct != null ? `%${n(b.karkas_randiman_pct * 100)}` : 'varsayılan')}</td>
                    <td>{tl(b.karkas_kg_fiyati)}</td>
                    <td>{kg != null ? `${n(kg)} kg` : '-'}</td>
                    <td><strong style={{ color: '#1e8449' }}>{tutar != null ? tl(tutar) : '-'}</strong></td>
                    <td style={{ display: 'flex', gap: 4 }}>
                      <button className="btn btn-sm" style={editBtn} onClick={() => bosDuveDuzenleAc(b)}>Düzenle</button>
                      <button className="btn btn-danger btn-sm" onClick={() => bosDuveSil(b.id)}>Sil</button>
                    </td>
                  </tr>
                );
              })}
              {parti.bos_duveler.length === 0 && <tr><td colSpan={8} style={{ textAlign: 'center', color: '#999' }}>Henüz kayıt yok</td></tr>}
            </tbody>
          </table>
          {ozet && (
            <div style={{ marginTop: 10, fontSize: 13, color: '#555' }}>
              Toplam karkas: <strong>{n(ozet.kalan_bos_duve_karkas_kg)} kg</strong> · Toplam tahmini gelir: <strong style={{ color: '#1e8449' }}>{tl(ozet.kalan_bos_duve_geliri)}</strong>
            </div>
          )}
        </div>
      )}

      {/* Bakım Desteği Verilmeyen Hayvan Sayısı — sadece düve partilerinde */}
      {parti.tip !== 'besilik' && (
        <div className="card">
          <div className="toolbar">
            <h3 style={{ margin: 0 }}>Bakım Desteği Verilmeyen Hayvan Sayısı</h3>
            <button className="btn btn-success btn-sm" onClick={bakimDestegiEkleAc}>+ Kayıt Ekle</button>
          </div>
          <table>
            <thead><tr><th>Destek Verilmeyen Hayvan Sayısı</th><th>Aylık Bakım Desteği Tutarı</th><th>Yıllık Toplam Gelir</th><th></th></tr></thead>
            <tbody>
              {parti.bakim_destegi_verilmeyenler.map((b: any) => (
                <tr key={b.id}>
                  <td>{n(b.hayvan_sayisi)}</td><td>{tl(b.aylik_tutar_tl)}</td>
                  <td><strong style={{ color: '#1e8449' }}>{tl((b.hayvan_sayisi || 0) * (b.aylik_tutar_tl || 0) * 12)}</strong></td>
                  <td style={{ display: 'flex', gap: 4 }}>
                    <button className="btn btn-sm" style={editBtn} onClick={() => bakimDestegiDuzenleAc(b)}>Düzenle</button>
                    <button className="btn btn-danger btn-sm" onClick={() => bakimDestegiSil(b.id)}>Sil</button>
                  </td>
                </tr>
              ))}
              {parti.bakim_destegi_verilmeyenler.length === 0 && <tr><td colSpan={4} style={{ textAlign: 'center', color: '#999' }}>Henüz kayıt yok</td></tr>}
            </tbody>
          </table>
          {ozet && <div style={{ marginTop: 10, fontSize: 13, color: '#555' }}>Toplam gelir: <strong style={{ color: '#1e8449' }}>{tl(ozet.bakim_destegi_verilmeyen_geliri)}</strong></div>}
        </div>
      )}

      {/* Aylık Bakım */}
      <div className="card">
        <div className="toolbar">
          <h3 style={{ margin: 0 }}>Aylık Bakım/Besleme Gideri</h3>
          <button className="btn btn-success btn-sm" onClick={bakimEkleAc}>+ Ay Ekle</button>
        </div>
        <table>
          <thead><tr><th>Yıl</th><th>Ay</th><th>Memur</th><th>İşçilik</th><th>Yem</th><th>Tahlil</th><th>Aşı</th><th>Bakılan Hayvan</th><th>Toplam</th><th>Hayvan Başı Günlük Gider</th><th></th></tr></thead>
          <tbody>
            {parti.aylik_bakim.map((k: any) => {
              const toplam = (k.memur_ucreti_tl || 0) + (k.disaridan_iscilik_tl || 0) + (k.yem_maliyeti_tl || 0) + (k.tahlil_ucreti_tl || 0) + (k.asi_ucreti_tl || 0);
              const gunSayisi = 30 * (k.gun_orani || 1);
              const gunlukGider = (k.bakilan_hayvan_sayisi && gunSayisi) ? toplam / k.bakilan_hayvan_sayisi / gunSayisi : null;
              return (
                <tr key={k.id}>
                  <td>{k.yil}</td><td>{k.ay}</td><td>{tl(k.memur_ucreti_tl)}</td><td>{tl(k.disaridan_iscilik_tl)}</td>
                  <td>{tl(k.yem_maliyeti_tl)}</td><td>{tl(k.tahlil_ucreti_tl)}</td><td>{tl(k.asi_ucreti_tl)}</td>
                  <td>{n(k.bakilan_hayvan_sayisi)}</td><td><strong>{tl(toplam)}</strong></td>
                  <td><strong style={{ color: '#1a5276' }}>{gunlukGider != null ? tl(gunlukGider) : '-'}</strong></td>
                  <td style={{ display: 'flex', gap: 4 }}>
                    <button className="btn btn-sm" style={editBtn} onClick={() => bakimDuzenleAc(k)}>Düzenle</button>
                    <button className="btn btn-danger btn-sm" onClick={() => bakimSil(k.id)}>Sil</button>
                  </td>
                </tr>
              );
            })}
            {parti.aylik_bakim.length === 0 && <tr><td colSpan={11} style={{ textAlign: 'center', color: '#999' }}>Henüz kayıt yok</td></tr>}
          </tbody>
        </table>
      </div>

      {/* Çıkış Kayıtları */}
      <div className="card">
        <div className="toolbar">
          <h3 style={{ margin: 0 }}>Çıkış Kayıtları (Ölen / Kesim / Canlı İade / Teslim Tutanağı)</h3>
          <button className="btn btn-success btn-sm" onClick={cikisEkleAc}>+ Kayıt Ekle</button>
        </div>
        <table>
          <thead><tr><th>Tip</th><th>Alt Tip</th><th>Hayvan Sayısı</th><th>Giriş</th><th>Çıkış</th><th>Karkas/Canlı Kg (baş.)</th><th>Fiyat</th><th>Hayvan Başı Maliyet</th><th></th></tr></thead>
          <tbody>
            {parti.cikis_kayitlari.map((c: any) => {
              const h = ozet?.cikis_kayitlari?.find((x: any) => x.kayit_id === c.id);
              const hayvanBasiMaliyet = h ? h.maliyet / (h.hayvan_sayisi || 1) : null;
              return (
                <tr key={c.id}>
                  <td>{CIKIS_TIPLERI[c.tip] || c.tip}</td>
                  <td>{ALT_TIPLER[c.tip]?.[c.alt_tip] || c.alt_tip || '-'}</td>
                  <td><strong>{n(c.hayvan_sayisi || 1)}</strong></td>
                  <td>{c.giris_tarihi || '-'}</td><td>{c.cikis_tarihi || '-'}</td>
                  <td>{c.karkas_kg ? `${n(c.karkas_kg)} kg (karkas)` : c.canli_agirlik_kg ? `${n(c.canli_agirlik_kg)} kg (canlı)` : '-'}</td>
                  <td>{c.karkas_kg_fiyati ? tl(c.karkas_kg_fiyati) : '-'}</td>
                  <td><strong style={{ color: '#c0392b' }}>{hayvanBasiMaliyet != null ? tl(hayvanBasiMaliyet) : '-'}</strong></td>
                  <td style={{ display: 'flex', gap: 4 }}>
                    <button className="btn btn-sm" style={editBtn} onClick={() => cikisDuzenleAc(c)}>Düzenle</button>
                    <button className="btn btn-danger btn-sm" onClick={() => cikisSil(c.id)}>Sil</button>
                  </td>
                </tr>
              );
            })}
            {parti.cikis_kayitlari.length === 0 && <tr><td colSpan={9} style={{ textAlign: 'center', color: '#999' }}>Henüz kayıt yok</td></tr>}
          </tbody>
        </table>
        {ozet?.cikis_kayitlari && (
          <div style={{ marginTop: 10, fontSize: 13, color: '#555' }}>
            Hesaplanan toplam çıkış zararı: <strong style={{ color: '#c0392b' }}>{tl(ozet.toplam_cikis_zarari)}</strong>
          </div>
        )}
      </div>

      {/* Ödeme Planı — sadece vadeli satış */}
      {parti.borclanma_tipi === 'vadeli_satis' && (
        <div className="card">
          <h3 style={{ marginTop: 0 }}>Ödeme Planı (Madde 11 — %25/180g, %50/270g, %75/360g, %100/450g)</h3>
          <table>
            <thead><tr><th>Oran</th><th>Vade Tarihi</th><th>Planlanan Tutar</th><th>Ödenen</th><th>Ödeme Tarihi</th><th>Durum</th><th></th></tr></thead>
            <tbody>
              {parti.odeme_plani.map((o: any) => (
                <tr key={o.id}>
                  <td>%{o.oran_pct}</td><td>{o.vade_tarihi || '-'}</td><td>{tl(o.planlanan_tutar_tl)}</td>
                  <td>{tl(o.odenen_tutar_tl)}</td><td>{o.odeme_tarihi || '-'}</td>
                  <td>{o.durum === 'odendi' ? '✅ Ödendi' : o.durum === 'gecikti' ? '⚠️ Gecikti' : '⏳ Bekliyor'}</td>
                  <td><button className="btn btn-primary btn-sm" onClick={() => odemeKaydet(o.id, o.odenen_tutar_tl)}>Ödeme Kaydet</button></td>
                </tr>
              ))}
              {parti.odeme_plani.length === 0 && <tr><td colSpan={7} style={{ textAlign: 'center', color: '#999' }}>Teslim tarihi girilince plan otomatik oluşur</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {/* Modallar */}
      {cagriModal && (
        <div className="modal-overlay" onClick={() => { setCagriModal(false); setCagriSecili(null); }}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header"><h3>{cagriSecili ? 'Satış Çağrısı Düzenle' : 'Satış Çağrısı Ekle'}</h3><button className="modal-close" onClick={() => { setCagriModal(false); setCagriSecili(null); }}>×</button></div>
            <div className="modal-body">
              <div className="form-group"><label>Çağrı No/Adı *</label><input className="form-control" value={cagriForm.cagri_no} onChange={e => setCagriForm({ ...cagriForm, cagri_no: e.target.value })} placeholder="Örn: 1. Çağrı" /></div>
              <div className="form-row">
                <div className="form-group"><label>Hayvan Sayısı</label><input className="form-control" type="number" value={cagriForm.hayvan_sayisi} onChange={e => setCagriForm({ ...cagriForm, hayvan_sayisi: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Birim Fiyat (TL)</label><input className="form-control" type="number" value={cagriForm.birim_fiyat_tl} onChange={e => setCagriForm({ ...cagriForm, birim_fiyat_tl: Number(e.target.value) })} /></div>
              </div>
              <div className="form-group"><label>Tarih</label><input className="form-control" type="date" value={cagriForm.tarih} onChange={e => setCagriForm({ ...cagriForm, tarih: e.target.value })} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn" style={{ background: '#eee' }} onClick={() => { setCagriModal(false); setCagriSecili(null); }}>İptal</button>
              <button className="btn btn-primary" onClick={cagriEkle}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {bakimModal && (
        <div className="modal-overlay" onClick={() => { setBakimModal(false); setBakimSecili(null); }}>
          <div className="modal" style={{ width: 560 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header"><h3>{bakimSecili ? 'Aylık Bakım Gideri Düzenle' : 'Aylık Bakım Gideri Ekle'}</h3><button className="modal-close" onClick={() => { setBakimModal(false); setBakimSecili(null); }}>×</button></div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group"><label>Yıl</label><input className="form-control" type="number" value={bakimForm.yil} onChange={e => setBakimForm({ ...bakimForm, yil: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Ay</label><input className="form-control" type="number" min={1} max={12} value={bakimForm.ay} onChange={e => setBakimForm({ ...bakimForm, ay: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Gün Oranı (kısmi ay için, örn 0.5)</label><input className="form-control" type="number" step="0.01" value={bakimForm.gun_orani} onChange={e => setBakimForm({ ...bakimForm, gun_orani: Number(e.target.value) })} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Memur Ücreti (TL)</label><input className="form-control" type="number" value={bakimForm.memur_ucreti_tl} onChange={e => setBakimForm({ ...bakimForm, memur_ucreti_tl: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Dışarıdan İşçilik (TL)</label><input className="form-control" type="number" value={bakimForm.disaridan_iscilik_tl} onChange={e => setBakimForm({ ...bakimForm, disaridan_iscilik_tl: Number(e.target.value) })} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Yem Maliyeti (TL)</label><input className="form-control" type="number" value={bakimForm.yem_maliyeti_tl} onChange={e => setBakimForm({ ...bakimForm, yem_maliyeti_tl: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Bakılan Hayvan Sayısı</label><input className="form-control" type="number" value={bakimForm.bakilan_hayvan_sayisi} onChange={e => setBakimForm({ ...bakimForm, bakilan_hayvan_sayisi: Number(e.target.value) })} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Tahlil Ücreti (TL)</label><input className="form-control" type="number" value={bakimForm.tahlil_ucreti_tl} onChange={e => setBakimForm({ ...bakimForm, tahlil_ucreti_tl: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Aşı Ücreti (TL)</label><input className="form-control" type="number" value={bakimForm.asi_ucreti_tl} onChange={e => setBakimForm({ ...bakimForm, asi_ucreti_tl: Number(e.target.value) })} /></div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" style={{ background: '#eee' }} onClick={() => { setBakimModal(false); setBakimSecili(null); }}>İptal</button>
              <button className="btn btn-primary" onClick={bakimEkle}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {cikisModal && (
        <div className="modal-overlay" onClick={() => { setCikisModal(false); setCikisSecili(null); }}>
          <div className="modal" style={{ width: 560 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header"><h3>{cikisSecili ? 'Çıkış Kaydı Düzenle' : 'Çıkış Kaydı Ekle'}</h3><button className="modal-close" onClick={() => { setCikisModal(false); setCikisSecili(null); }}>×</button></div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group">
                  <label>Tip *</label>
                  <select className="form-control" value={cikisForm.tip} onChange={e => setCikisForm({ ...cikisForm, tip: e.target.value, alt_tip: Object.keys(ALT_TIPLER[e.target.value] || {})[0] || '' })}>
                    {Object.entries(CIKIS_TIPLERI).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                {Object.keys(ALT_TIPLER[cikisForm.tip] || {}).length > 0 && (
                  <div className="form-group">
                    <label>Alt Tip</label>
                    <select className="form-control" value={cikisForm.alt_tip} onChange={e => setCikisForm({ ...cikisForm, alt_tip: e.target.value })}>
                      {Object.entries(ALT_TIPLER[cikisForm.tip]).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                    </select>
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>Hayvan Sayısı * <small style={{color:'#999', fontWeight:'normal'}}>(aynı özelliklerle çıkan hayvan adedi — maliyet/getiri bu sayıyla çarpılır)</small></label>
                <input className="form-control" type="number" min={1} value={cikisForm.hayvan_sayisi}
                  onChange={e => setCikisForm({ ...cikisForm, hayvan_sayisi: Number(e.target.value) })} />
              </div>

              {cikisForm.tip === 'kesim' && (
                <div className="form-group">
                  <label>Hayvan Cinsiyeti (dişi kesimlerde katsayı için — besilik/erkekte boş bırakın)</label>
                  <select className="form-control" value={cikisForm.hayvan_cinsiyeti} onChange={e => setCikisForm({ ...cikisForm, hayvan_cinsiyeti: e.target.value })}>
                    <option value="">Erkek / Belirtilmemiş</option>
                    <option value="inek">İnek (×0,90)</option>
                    <option value="duve">Düve (×0,96)</option>
                  </select>
                </div>
              )}

              <div className="form-row">
                <div className="form-group"><label>Giriş Tarihi (boş bırakılırsa parti teslim tarihi)</label><input className="form-control" type="date" value={cikisForm.giris_tarihi} onChange={e => setCikisForm({ ...cikisForm, giris_tarihi: e.target.value })} /></div>
                <div className="form-group"><label>Çıkış Tarihi *</label><input className="form-control" type="date" value={cikisForm.cikis_tarihi} onChange={e => setCikisForm({ ...cikisForm, cikis_tarihi: e.target.value })} /></div>
              </div>

              {cikisForm.tip === 'kesim' && (
                <div className="form-row">
                  <div className="form-group"><label>Sıcak Karkas Kg (hayvan başına)</label><input className="form-control" type="number" value={cikisForm.karkas_kg} onChange={e => setCikisForm({ ...cikisForm, karkas_kg: e.target.value })} /></div>
                  <div className="form-group"><label>Karkas Kg Fiyatı (boşsa parti fiyatı kullanılır)</label><input className="form-control" type="number" value={cikisForm.karkas_kg_fiyati} onChange={e => setCikisForm({ ...cikisForm, karkas_kg_fiyati: e.target.value })} /></div>
                </div>
              )}
              {cikisForm.tip === 'canli_iade' && (
                <div className="form-row">
                  <div className="form-group"><label>Canlı Ağırlık Kg (hayvan başına, tokluk firesi düşülmeden)</label><input className="form-control" type="number" value={cikisForm.canli_agirlik_kg} onChange={e => setCikisForm({ ...cikisForm, canli_agirlik_kg: e.target.value })} /></div>
                  <div className="form-group"><label>Karkas Kg Fiyatı (boşsa parti fiyatı kullanılır)</label><input className="form-control" type="number" value={cikisForm.karkas_kg_fiyati} onChange={e => setCikisForm({ ...cikisForm, karkas_kg_fiyati: e.target.value })} /></div>
                </div>
              )}

              <div className="form-group"><label>Açıklama</label><textarea className="form-control" value={cikisForm.aciklama} onChange={e => setCikisForm({ ...cikisForm, aciklama: e.target.value })} rows={2} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn" style={{ background: '#eee' }} onClick={() => { setCikisModal(false); setCikisSecili(null); }}>İptal</button>
              <button className="btn btn-primary" onClick={cikisEkle}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {buzagiModal && (
        <div className="modal-overlay" onClick={() => { setBuzagiModal(false); setBuzagiSecili(null); }}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header"><h3>{buzagiSecili ? 'Buzağı Satışı Düzenle' : 'Buzağı Satışı Ekle'}</h3><button className="modal-close" onClick={() => { setBuzagiModal(false); setBuzagiSecili(null); }}>×</button></div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group"><label>Satış Tarihi</label><input className="form-control" type="date" value={buzagiForm.satis_tarihi} onChange={e => setBuzagiForm({ ...buzagiForm, satis_tarihi: e.target.value })} /></div>
                <div className="form-group"><label>Satılan Sayı</label><input className="form-control" type="number" value={buzagiForm.satilan_sayi} onChange={e => setBuzagiForm({ ...buzagiForm, satilan_sayi: Number(e.target.value) })} /></div>
              </div>
              <div className="form-group"><label>Birim Fiyat (TL)</label><input className="form-control" type="number" value={buzagiForm.birim_fiyat_tl} onChange={e => setBuzagiForm({ ...buzagiForm, birim_fiyat_tl: Number(e.target.value) })} /></div>
              <div className="form-group"><label>Açıklama</label><textarea className="form-control" value={buzagiForm.aciklama} onChange={e => setBuzagiForm({ ...buzagiForm, aciklama: e.target.value })} rows={2} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn" style={{ background: '#eee' }} onClick={() => { setBuzagiModal(false); setBuzagiSecili(null); }}>İptal</button>
              <button className="btn btn-primary" onClick={buzagiEkle}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {yemModal && (
        <div className="modal-overlay" onClick={() => { setYemModal(false); setYemSecili(null); }}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header"><h3>{yemSecili ? 'Yem Desteği Düzenle' : 'Yem Desteği Ekle'}</h3><button className="modal-close" onClick={() => { setYemModal(false); setYemSecili(null); }}>×</button></div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group"><label>Yem Desteği Verilen Hayvan Sayısı</label><input className="form-control" type="number" value={yemForm.hayvan_sayisi} onChange={e => setYemForm({ ...yemForm, hayvan_sayisi: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Hayvan Başına Aylık Tutar (TL)</label><input className="form-control" type="number" value={yemForm.aylik_tutar_tl} onChange={e => setYemForm({ ...yemForm, aylik_tutar_tl: Number(e.target.value) })} /></div>
              </div>
              <div style={{ fontSize: 12, color: '#1a5276', background: '#eaf2fb', padding: '6px 10px', borderRadius: 4, marginBottom: 10 }}>
                Yıllık toplam: <strong>{tl((yemForm.hayvan_sayisi || 0) * (yemForm.aylik_tutar_tl || 0) * 12)}</strong>
              </div>
              <div className="form-group"><label>Açıklama</label><textarea className="form-control" value={yemForm.aciklama} onChange={e => setYemForm({ ...yemForm, aciklama: e.target.value })} rows={2} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn" style={{ background: '#eee' }} onClick={() => { setYemModal(false); setYemSecili(null); }}>İptal</button>
              <button className="btn btn-primary" onClick={yemEkle}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {tarsimModal && (
        <div className="modal-overlay" onClick={() => { setTarsimModal(false); setTarsimSecili(null); }}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header"><h3>{tarsimSecili ? 'Tarsım Düzenle' : 'Tarsım Ekle'}</h3><button className="modal-close" onClick={() => { setTarsimModal(false); setTarsimSecili(null); }}>×</button></div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group"><label>Tarsım Ödemesi Yapılacak Hayvan Sayısı</label><input className="form-control" type="number" value={tarsimForm.hayvan_sayisi} onChange={e => setTarsimForm({ ...tarsimForm, hayvan_sayisi: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Tarsım Birim Tutarı (TL)</label><input className="form-control" type="number" value={tarsimForm.birim_tutar_tl} onChange={e => setTarsimForm({ ...tarsimForm, birim_tutar_tl: Number(e.target.value) })} /></div>
              </div>
              <div style={{ fontSize: 12, color: '#1a5276', background: '#eaf2fb', padding: '6px 10px', borderRadius: 4, marginBottom: 10 }}>
                Toplam Tarsım tutarı: <strong>{tl((tarsimForm.hayvan_sayisi || 0) * (tarsimForm.birim_tutar_tl || 0))}</strong>
              </div>
              <div className="form-group"><label>Açıklama</label><textarea className="form-control" value={tarsimForm.aciklama} onChange={e => setTarsimForm({ ...tarsimForm, aciklama: e.target.value })} rows={2} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn" style={{ background: '#eee' }} onClick={() => { setTarsimModal(false); setTarsimSecili(null); }}>İptal</button>
              <button className="btn btn-primary" onClick={tarsimEkle}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {bosDuveModal && (
        <div className="modal-overlay" onClick={() => { setBosDuveModal(false); setBosDuveSecili(null); }}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header"><h3>{bosDuveSecili ? 'Kalan Boş Düve Düzenle' : 'Kalan Boş Düve Ekle'}</h3><button className="modal-close" onClick={() => { setBosDuveModal(false); setBosDuveSecili(null); }}>×</button></div>
            <div className="modal-body">
              <div className="form-group">
                <label>Tip *</label>
                <select className="form-control" value={bosDuveForm.tip} onChange={e => setBosDuveForm({ ...bosDuveForm, tip: e.target.value })}>
                  {Object.entries(BOS_DUVE_TIPLERI).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Hayvan Sayısı</label><input className="form-control" type="number" value={bosDuveForm.hayvan_sayisi} onChange={e => setBosDuveForm({ ...bosDuveForm, hayvan_sayisi: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Ortalama Canlı Ağırlık (kg)</label><input className="form-control" type="number" value={bosDuveForm.ortalama_canli_agirlik_kg} onChange={e => setBosDuveForm({ ...bosDuveForm, ortalama_canli_agirlik_kg: Number(e.target.value) })} /></div>
              </div>
              {bosDuveForm.tip === 'kesim' ? (
                <div className="form-group"><label>Karkas Randıman % (örn 0.58) — boş bırakılırsa protokol varsayılanı</label><input className="form-control" type="number" step="0.01" value={bosDuveForm.karkas_randiman_pct} onChange={e => setBosDuveForm({ ...bosDuveForm, karkas_randiman_pct: e.target.value })} /></div>
              ) : (
                <div style={{ fontSize: 12, color: '#888', marginBottom: 10 }}>Canlı iadede randıman sabit %50 (Madde 12/3) — ayrıca girilmez.</div>
              )}
              <div className="form-group"><label>Karkas Kg Fiyatı (TL)</label><input className="form-control" type="number" value={bosDuveForm.karkas_kg_fiyati} onChange={e => setBosDuveForm({ ...bosDuveForm, karkas_kg_fiyati: Number(e.target.value) })} /></div>
              <div className="form-group"><label>Açıklama</label><textarea className="form-control" value={bosDuveForm.aciklama} onChange={e => setBosDuveForm({ ...bosDuveForm, aciklama: e.target.value })} rows={2} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn" style={{ background: '#eee' }} onClick={() => { setBosDuveModal(false); setBosDuveSecili(null); }}>İptal</button>
              <button className="btn btn-primary" onClick={bosDuveEkle}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {bakimDestegiModal && (
        <div className="modal-overlay" onClick={() => { setBakimDestegiModal(false); setBakimDestegiSecili(null); }}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header"><h3>{bakimDestegiSecili ? 'Bakım Desteği Verilmeyen Düzenle' : 'Bakım Desteği Verilmeyen Ekle'}</h3><button className="modal-close" onClick={() => { setBakimDestegiModal(false); setBakimDestegiSecili(null); }}>×</button></div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group"><label>Destek Verilmeyen Hayvan Sayısı</label><input className="form-control" type="number" value={bakimDestegiForm.hayvan_sayisi} onChange={e => setBakimDestegiForm({ ...bakimDestegiForm, hayvan_sayisi: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Aylık Bakım Desteği Tutarı (TL)</label><input className="form-control" type="number" value={bakimDestegiForm.aylik_tutar_tl} onChange={e => setBakimDestegiForm({ ...bakimDestegiForm, aylik_tutar_tl: Number(e.target.value) })} /></div>
              </div>
              <div style={{ fontSize: 12, color: '#1a5276', background: '#eaf2fb', padding: '6px 10px', borderRadius: 4, marginBottom: 10 }}>
                Yıllık toplam: <strong>{tl((bakimDestegiForm.hayvan_sayisi || 0) * (bakimDestegiForm.aylik_tutar_tl || 0) * 12)}</strong>
              </div>
              <div className="form-group"><label>Açıklama</label><textarea className="form-control" value={bakimDestegiForm.aciklama} onChange={e => setBakimDestegiForm({ ...bakimDestegiForm, aciklama: e.target.value })} rows={2} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn" style={{ background: '#eee' }} onClick={() => { setBakimDestegiModal(false); setBakimDestegiSecili(null); }}>İptal</button>
              <button className="btn btn-primary" onClick={bakimDestegiEkle}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
